module.exports = __webpack_public_path__ + "static/media/app-bar-save.fe2c2a6b.svg";